"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsync = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const immutability_helper_1 = __importDefault(require("immutability-helper"));
const initialState = {
    data: undefined,
    meta: undefined,
    error: undefined,
    busy: false,
    complete: false,
};
const useAsync = (create, config = {}) => {
    const [state, setState] = (0, react_1.useState)(initialState);
    const run = (args, meta) => {
        let canceled = false;
        setState((state) => {
            let updatePayload = {
                error: { $set: undefined },
                busy: { $set: true },
                complete: { $set: false },
            };
            if (!config.keepData)
                (0, lodash_1.set)(updatePayload, 'data', { $set: undefined });
            return (0, immutability_helper_1.default)(state, updatePayload);
        });
        const { task, abort } = create();
        task(args)
            .then((res) => {
            if (canceled)
                return;
            setState((state) => (0, immutability_helper_1.default)(state, {
                meta: { $set: meta },
                data: { $set: res },
                busy: { $set: false },
                complete: { $set: true },
            }));
        })
            .catch((err) => {
            if (canceled)
                return;
            setState((state) => (0, immutability_helper_1.default)(state, {
                meta: { $set: meta },
                error: { $set: err },
                busy: { $set: false },
                complete: { $set: true },
            }));
        });
        return () => {
            canceled = true;
            if (abort)
                abort();
        };
    };
    const task = (args, m) => create().task(args, m);
    return Object.assign(Object.assign({}, state), { run, task });
};
exports.useAsync = useAsync;
//# sourceMappingURL=async.js.map